export default {
  modalTitle: 'My Client Space has a new look!',
  modalText: 'With its clean design and streamlined, more intuitive navigation, My Client Space now has everything you want:',
  exploreButton: 'Let’s go!',
  modalLineText1: 'Completely revamped home page',
  modalLineText2: 'Improved Profile, Secure Messaging and Documents sections',
  modalLineText3: 'New notification and required action features',
  modalLineText4: 'Seamless, optimized experience for all your devices',

};
